const Msg_Change_Interval = 100;
export default class TitleMessager {
    private static instance: TitleMessager;
    private msgs: Array<string> = [];
    private timerId: number = null;
    private originTitle: string = '';
    private currIndex: number = 0;
    private constructor() {
        this.originTitle = document.title || '美团旅行境内度假商家中心';
        this.msgs.push(this.originTitle);
    }

    show(msg: string): void {
        if (!this.timerId) {
            this.timerId = window.setInterval(() => {
                let inx = this.currIndex++ % this.msgs.length;
                let newTitle = this.msgs[inx];
                document.title = newTitle;
            }, Msg_Change_Interval);
        }
        this.msgs.push(msg);
    }

    reset(msg: string) {
        if (this.timerId) {
            window.clearInterval(this.timerId);
            if (msg) {
                let inx = this.msgs.indexOf(msg);
                this.msgs.splice(inx, 1);
            } else {
                this.msgs = [this.originTitle];
            }
        }
        document.title = this.originTitle;
    }

    static getInstance() {
        if (!TitleMessager.instance) {
            TitleMessager.instance = new TitleMessager();
        }
        return TitleMessager.instance;
    }

    static install(Vue) {
        Vue.prototype.$TitleMessager = TitleMessager.getInstance();
    }
}



// WEBPACK FOOTER //
// ./src/components/TitleMessager/TitleMessager.ts